import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PopupHeader, ScrollableContainer } from '@streamr/tv-ui';
import { EmbeddedCheckout, EmbeddedCheckoutProvider, } from '@stripe/react-stripe-js';
import { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { assert } from '../../utils/assert';
import { Popup } from '../../utils/popups';
import { AbstractPopup, DismissalReason } from './AbstractPopup';
import { PopupCssPreset } from './Popup.styles';
function CheckoutPopup({ resolve, reject, createCheckoutSession, stripePromise, }) {
    const sessionIdRef = useRef(undefined);
    const fetchClientSecret = useCallback(async () => {
        const { id, clientSecret } = await createCheckoutSession();
        sessionIdRef.current = id;
        return clientSecret;
    }, [createCheckoutSession]);
    const onComplete = useCallback(() => {
        assert(sessionIdRef.current, 'Missing checkout session id');
        resolve(sessionIdRef.current);
    }, [resolve]);
    return (_jsxs(CheckoutPopupRoot, { reject: (reason) => {
            if (reason === DismissalReason.Backdrop) {
                return;
            }
            reject(reason);
        }, children: [_jsx(PopupHeader, { onCloseButtonClick: () => {
                    reject(DismissalReason.CloseButton);
                }, children: "Complete your purchase" }), _jsx(CheckoutFormOuter, { children: _jsx(ScrollableContainer, { children: _jsx(CheckoutFormContainer, { children: _jsx(EmbeddedCheckoutProvider, { stripe: stripePromise, options: { fetchClientSecret, onComplete }, children: _jsx(EmbeddedCheckout, {}) }) }) }) })] }));
}
const CheckoutFormOuter = styled.div `
    padding-bottom: 1.5rem;
`;
const CheckoutFormContainer = styled.div `
    padding: 0 1.5rem;
    max-height: calc(var(--vh-100, 100vh) - 2rem - 5.5rem - 1.5rem);

    iframe {
        border-radius: 1.125rem;
    }
`;
const CheckoutPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Padding: 0;
    --Popup_Width: 32rem;

    /* Popup header */
    --PopupHeader_Padding: 1.5rem;
`;
export const checkoutPopup = Popup.create(CheckoutPopup);
